@if (isAccountingEdit && issue) {
  <div id="taxAccountEditModal">
    <div class="modal-overlay taxAccountingModal">
    <div
      #taxAccEDIT
      id="edit-modal"
      class="modal-container"
      [style.left.px]="positionX"
      [style.top.px]="positionY"
    >
      <!-- MODAL HEADER -->
      <div class="modal-header" (mousedown)="startDrag($event)">
        <h5 class="modal-title">Edit Tax Accounting</h5>
        <div class="d-flex justify-content-center align-items-center gap-3 actionColumn">
          <!-- SAVE Records -->
          <button type="button" class="btn btn-link p-0 successIcon iconCSS" (click)="saveRecord()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="25"
              height="25"
              fill="none"
              stroke="#0b2d71"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <title>Save Records</title>
              <path d="M6 4h9l3 3v12H6z" />
              <path d="M9 4v5h6V4" />
              <path d="M9 14l2 2 4-4" />
            </svg>
          </button>
          <!-- CLOSE Form-->
          <button type="button" class="btn btn-link p-0 dangerIcon iconCSS" (click)="closeForm()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="#000"
              stroke-width="2.4"
              stroke-linecap="round"
            >
              <title>Close Form</title>
              <path d="M6 6L18 18" />
              <path d="M18 6L6 18" />
            </svg>
          </button>
        </div>
      </div>

      <!-- (MODAL_Body) Issue Details  -->
      <div class="modal-body backgroundGrey p-0">
        <app-tax-accounting-header> </app-tax-accounting-header>
        <app-tax-accounting-records #recordsContainer [tbbsStatus]="tbbsStatus" [issue]="issue" [editMode]="true">
        </app-tax-accounting-records>
      </div>
    </div>
  </div>
  </div>
}
